<template>
<v-card outlined>
    <v-data-table
        :headers="headers"
        :items="list"
        :items-per-page="-1"
        :loading="fetching"
        hide-default-header
        hide-default-footer
        disable-pagination
        disable-filtering
        >
        <!-- eslint-disable-next-line -->
        <template v-slot:item.horario="{ item }">
            <v-btn class="mr-2" text small @click="open(item, 'window')">
                <v-icon class="mr-2" small>mdi mdi-eye-outline</v-icon>
                {{ item.juego }} - {{ item.horario }} 
            </v-btn>
        </template>
        <!-- eslint-disable-next-line -->
        <template v-slot:item.venta="{ item }">
            <Venta :reporte="item"/>
        </template>
        <!-- eslint-disable-next-line -->
        <template v-slot:item.comision="{ item }">
            <Comision :reporte="item"/>
        </template>
        <!-- eslint-disable-next-line -->
        <template v-slot:item.premio="{ item }">
            <Premio :reporte="item"/>
        </template>
        <!-- eslint-disable-next-line -->
        <template v-slot:item.total="{ item }">
            <Total :reporte="item"/>
        </template>
        <!-- eslint-disable-next-line -->
        <template v-slot:item.banqueo="{ item }">
            <Banqueo :reporte="item"/>
        </template>
    </v-data-table>
</v-card>
</template>
<script>

import ReportePorSorteoService from '@/services/reporte/ventas/ReportePorSorteoService';

import Venta from '@/components/entities/reporte/components/venta.vue';
import Comision from '@/components/entities/reporte/components/comision.vue';
import Premio from '@/components/entities/reporte/components/premio.vue';
import Total from '@/components/entities/reporte/components/total.vue';
import Banqueo from '@/components/entities/reporte/components/banqueo.vue';

export default {
    components: {   
        Venta,
        Comision,
        Premio,
        Total,
        Banqueo,
    },
    props: {
        context: {
            defaults: 'comercio',
        },
        params: {
            defaults: function() {
                return {};
            },
        },
    },
    data: function() { 
        return {
            list: [],
            fetching: false,
            expanded: [],
        }
    },
    computed: {
        headers: function () {
            return [
                { text: 'Juego', align: 'start', value: 'horario' },
                { text: 'Ventas', value: 'venta' },
                { text: 'Comisión', value: 'comision' },
                { text: 'Premios', value: 'premio' },
                { text: 'Total', value: 'total'},
                { text: 'Banqueo', value: 'banqueo' },
            ];
        },
        divisa: function () {
            return this.$store.getters['persist/divisa/selected'];
        },
        user: function () {
            return this.$store.getters['persist/auth/user'];
        },
    },
    methods: {
        fetch: async function () {
            this.fetching = true;
            this.list = [];

            const comercio = [];
            if (this.user.comercio_type !== 'operadora') comercio[this.getComType(this.user.comercio_type)] = this.user.comercio_id;

            const params = { ... this.params, divisa_id: this.divisa.id, ...comercio };

            if (this.context == 'sistema') {
                params['group_by'] = 'sistema';
                params['comercio_type'] = 'sistema';
            }

            try {
                const {
                    reportList
                } = await ReportePorSorteoService.getConsolidado(params);

                this.list = reportList;
            } catch (error) {
                console.log(error);
            }

            this.fetching = false;
        },
        getComType: function (comercioType) {
            return {'master': 'master_id', 'comercializadora': 'comercializadora_id', 'grupo': 'grupo_id', 'taquilla': 'taquilla_id'}[comercioType];
        },
        open: function (reporte, context = 'tab') {
            const comercio = [];
            if (this.user.comercio_type !== 'operadora') comercio[this.getComType(reporte.comercio_type)] = reporte.comercio_id;
            const route = this.$router.resolve({
                name: ({
                    'comercio': 'reporte.general',
                    'sistema': 'operadora.sistema.reporte.general',
                })[this.context],
                query: {
                    ... this.params,
                    juego_id: reporte.juego_id,
                    juego_sorteo_id: reporte.juego_sorteo_id,
                    ... context == 'window' ? { 'minimal': 1, 'no-layout': 1 }: {},
                }
            });
            if (context == 'tab') return window.open(new URL(route.href, window.location.origin), '_blank').focus();
            if (context == 'window') return window.open(new URL(route.href, window.location.origin), '_blank', 'titlebar=no, status=no, menubar=no, height=600 width=1280');
        },
    },
    watch: {
        'fetching': function (fetching) {
            this.$emit('update:loading', fetching);
        }
    },
    mounted: function () {
        this.fetch();
    }
}
</script>